define.alias("shared/utils/formatters/format-hashtag-trends", "preview-grid/utils/formatters/format-hashtag-trends");